import { CUSTOM_CONTENT_FETCHED } from '../actions/customContents';

const initialState = {};

export default (state = initialState, action) => {
  switch (action.type) {
    case CUSTOM_CONTENT_FETCHED:
      return {
        ...state,
        [action.contentType]: action.content
      };
    default:
      return state;
  }
};
